export const appConifg = {
  Map: {
    AerialImagery:
      process.env.REACT_APP_GIS_BASE_URL +
      "serverimage/rest/services/Aerial_Imagery_2019/ImageServer",
    PortalUrl: process.env.REACT_APP_ARCGIS_PORTAL_URL,
  },
  Address: {
    GeometryServiceUrl:
      process.env.REACT_APP_GIS_BASE_URL +
      "server/rest/services/Utilities/Geometry/GeometryServer",
    LocatorServiceUrl:
      process.env.REACT_APP_GIS_BASE_URL +
      process.env.REACT_APP_LOCATORSERVICE_URL,
    SuggestionsUrlEN:
      process.env.REACT_APP_GIS_BASE_URL +
      process.env.REACT_APP_LOCATOR_URL_EN +
      "/suggest",
    FindAddressUrlEN:
      process.env.REACT_APP_GIS_BASE_URL +
      process.env.REACT_APP_LOCATOR_URL_EN +
      "/findAddressCandidates",
    SuggestionsUrlAR:
      process.env.REACT_APP_GIS_BASE_URL +
      process.env.REACT_APP_LOCATOR_URL_AR +
      "/suggest",
    FindAddressUrlAR:
      process.env.REACT_APP_GIS_BASE_URL +
      process.env.REACT_APP_LOCATOR_URL_AR +
      "/findAddressCandidates",
    ParcelServiceUrl:
      process.env.REACT_APP_GIS_BASE_URL +
      "server/rest/services/RakLocatorMap/RakLocatorMap/MapServer/4",
    StreetsServiceUrl:
      process.env.REACT_APP_GIS_BASE_URL +
      "server/rest/services/RakLocatorMap/RakLocatorMap/MapServer/2",
    PostalServiceUrl:
      process.env.REACT_APP_GIS_BASE_URL +
      "server/rest/services/RakLocatorMap/RakLocatorMap/MapServer/3",
    AreaServiceUrl:
      process.env.REACT_APP_GIS_BASE_URL +
      "server/rest/services/RakLocatorMap/RakLocatorMap/MapServer/5",
    PointAddressServiceUrl:
      process.env.REACT_APP_GIS_BASE_URL +
      "server/rest/services/RakLocatorMap/RakLocatorMap/MapServer/1",
    RakStreetsTileEnglish:
      process.env.REACT_APP_GIS_BASE_URL +
      "server/rest/services/Hosted/AddressBaseMap/VectorTileServer",
    RakStreetsTileArabic:
      process.env.REACT_APP_GIS_BASE_URL +
      "server/rest/services/Hosted/AddressBaseMapArabic/VectorTileServer",
    RakStreetsMapEnglish:
      process.env.REACT_APP_GIS_BASE_URL +
      "server/rest/services/RakLocatorMap/AddressBaseMapEnglishHollow/MapServer",
    RakStreetsMapArabic:
      process.env.REACT_APP_GIS_BASE_URL +
      "server/rest/services/RakLocatorMap/AddressBaseMapArabicHollow/MapServer",
    RakBoundaryMapEnglish:
      process.env.REACT_APP_GIS_BASE_URL +
      "server/rest/services/RakLocatorMap/AddressBaseMapEnglish/MapServer",
      RakBoundarysMapArabic:
      process.env.REACT_APP_GIS_BASE_URL +
      "server/rest/services/RakLocatorMap/AddressBaseMapArabic/MapServer",
    AddressApiUrl: process.env.REACT_APP_BASE_URL + "api",
    SiteName: process.env.REACT_APP_SITE_NAME,
    ShareAddressBaseUrl : process.env.REACT_APP_SHARE_ADDRESS_BASE_URL
  },
  ProxyUrl: process.env.REACT_APP_PROXY_URL,
  IssueInbox: {
    OpenIssueTypeId: 1,
    ClosedIssueTypeId: 3,
  },
  AnonymousUser: {
    username: process.env.REACT_APP_ANONYMOUS_UN,
    password: process.env.REACT_APP_ANONYMOUS_PW,
  },
  UaePassDetails: {
    loginUrl: process.env.REACT_APP_UAEPASS_LOGIN_URL,
    clientId: process.env.REACT_APP_UAEPASS_CLIENT_ID,
    redirectUrl: process.env.REACT_APP_UAEPASS_REDIRECT_URL,
    logoutUrl: process.env.REACT_APP_UAEPASS_LOGOUT_URL,
  }
};
